module.exports = __webpack_public_path__ + "img/ics_o_package_failed_crrnfd.be07aa74.svg";